import buttonStyles from '@/styles/buttons.module.css'
import iconCrossBlack from '../../assets/icons/icon_cross_black.svg'
import baseStyles from '../PasswordChangeDialog/passwordChangeDialog.module.css'
import textStyles from './uploadErrorDialog.module.css'

interface UploadErrorDialogProps {
  isOpen: boolean
  onClose: () => void
  message: string
}

const UploadErrorDialog = ({ isOpen, onClose, message }: UploadErrorDialogProps) => {
  if (!isOpen) return null

  const isExtensionError = /only\s*jpg,?\s*png,?\s*svg\s*are\s*allowed/i.test(message)

  return (
    <div
      className={`${baseStyles.overlayError}`}
      onClick={onClose}
      role="presentation"
      onKeyDown={(e) => {
        if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation()
          onClose()
        }
      }}
      tabIndex={-1}
    >
      <dialog
        className={`${baseStyles.dialog} ${textStyles.dialog} ${baseStyles.centerErrorDialog}`}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            e.stopPropagation()
            onClose()
          }
        }}
        open
        aria-modal="true"
      >
        <div className={textStyles.header}>
          <h2 className={textStyles.title}>Upload Error</h2>
          <button type="button" className={baseStyles.closeButton} onClick={onClose}>
            <img src={iconCrossBlack} alt="Close" />
          </button>
        </div>
        <div>
          {isExtensionError ? (
            <p className={textStyles.message}>
              Please upload a file with these extensions: {''}
              <span className={textStyles.messageHighlight}>jpg, png, svg.</span>
            </p>
          ) : (
            <p className={textStyles.message}>{message}</p>
          )}
        </div>
        <div className={textStyles.buttonsRow} style={{ marginTop: '10px' }}>
          <button
            type="button"
            className={buttonStyles['button-outline']}
            onClick={onClose}
            style={{ borderColor: '#E1E6EA', color: '#566676' }}
          >
            Cancel
          </button>
          <button type="button" className={buttonStyles['button-primary']} onClick={onClose}>
            Finish
          </button>
        </div>
      </dialog>
    </div>
  )
}

export default UploadErrorDialog
